export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5108.9c0161d9.jpg";